import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PasswordApp from 'PasswordApp';
import { Reqter } from 'sdk';
import Signin from 'page/signin';
import SignInCV from 'page/signin/siginCV';
import { Login } from 'page/auth/login';
import { SignUp } from 'page/auth/signUp';
import { useAuth } from './utilities/auth';
import { authHostname } from './api/ApiConfig';

interface IAuthProviderWithNavigate {
    children?: React.ReactNode;
}

export const AuthProviderWithNavigate = ({
    children,
}: IAuthProviderWithNavigate) => {
    const [locationSearchParams, setSearchParams] = useSearchParams();
    const { isAuthenticated, isLoading, loginWithCode, error } = useAuth();
    const page = window.location.pathname.split('/');

    useEffect(() => {
        if (
            page[1] === 'password' ||
            window.location.pathname === '/auth/sign-in/cv'
        ) {
            return;
        }

        if (
            locationSearchParams.get('code') !== null &&
            locationSearchParams.get('code') !== '' &&
            !isLoading &&
            error.message === '' &&
            !isAuthenticated
        ) {
            loginWithCode(locationSearchParams.get('code') || '');
        }

        if (
            !isAuthenticated &&
            !['callback', 'signin', 'login', 'signup'].includes(page[1])
        ) {
            const callback = `${window.location.origin}/callback`;
            const searchParams = new URLSearchParams();
            searchParams.append('client_id', 'public-client');
            searchParams.append('redirect_uri', callback);
            searchParams.append('scope', 'openid email profile federated:id');
            searchParams.append('response_type', 'code');
            searchParams.toString();

            sessionStorage.setItem('callbackURL', window.location.href);

            window.location.href = `${authHostname()}/dex/auth?${searchParams.toString()}#signin`;
        }

        if (isAuthenticated && !Reqter.isConnecting()) {
            Reqter.connect((err) => {
                // TODO add error handler, possibly a notification view
            });
        }
    }, []);

    if (page[1] === 'password') {
        return <PasswordApp />;
    }
    if (page[1] === 'signup') {
        return <SignUp />;
    }
    if (page[1] === 'login' || page[1] === 'signin') {
        return <Login />;
    }

    if (!isAuthenticated && window.location.pathname === '/auth/sign-in/cv') {
        return <SignInCV />;
    }

    return children;
};
